export const SpriteSheet = (
  <svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }}>
    <symbol id="check" viewBox="0 0 24 24" fill="none">
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
        strokeWidth="currentWidth"
        d="M4 11.432L9.377 17 20 6"
      />
    </symbol>
    <symbol id="delete" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="9" fill="currentColor" />
      <path
        stroke="white"
        strokeLinecap="square"
        strokeWidth="currentWidth"
        d="M15 15L9 9m6 0l-6 6"
      />
    </symbol>
    <symbol id="see-on" viewBox="0 0 24 24" fill="none">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="currentWidth"
        d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="currentWidth"
        d="M12 15.7a3.7 3.7 0 1 0 0-7.4 3.7 3.7 0 0 0 0 7.4z"
      />
    </symbol>
    <symbol id="see-off" viewBox="0 0 24 24" fill="none">
      <path
        d="M2 2L22 22"
        stroke="currentColor"
        strokeWidth="currentWidth"
        strokeLinecap="round"
      />
      <path
        d="M3.92809 6.94633C3.73173 7.13759 3.54377 7.32982 3.36433 7.52123C2.39104 8.5594 1.64707 9.59491 1.14635 10.3702C0.895554 10.7585 0.704636 11.0834 0.575447 11.3131C0.510826 11.4279 0.461572 11.5191 0.42792 11.5827C0.411091 11.6145 0.398157 11.6395 0.389146 11.657L0.378574 11.6777L0.3755 11.6838L0.374517 11.6857L0.377384 11.6873L0.376845 11.6884L0.373904 11.6869C0.275369 11.884 0.275369 12.116 0.373904 12.313L0.3755 12.3162L0.378574 12.3223L0.389146 12.343C0.398157 12.3605 0.411091 12.3854 0.42792 12.4172C0.461572 12.4808 0.510826 12.572 0.575447 12.6869C0.704636 12.9166 0.895554 13.2414 1.14635 13.6298C1.64707 14.4051 2.39104 15.4406 3.36433 16.4787C5.29814 18.5415 8.22035 20.7 12 20.7C13.7026 20.7 15.2312 20.262 16.5738 19.5921L15.5215 18.5397C14.4537 19.0102 13.2774 19.3 12 19.3C8.77966 19.3 6.20187 17.4585 4.38568 15.5212C3.48397 14.5594 2.79043 13.5949 2.32241 12.8702C2.08883 12.5085 1.91256 12.2084 1.79565 12.0006V11.9994C1.91256 11.7916 2.08883 11.4914 2.32241 11.1298C2.79043 10.4051 3.48397 9.44057 4.38568 8.47875C4.55644 8.2966 4.73394 8.1153 4.91806 7.9363L3.92809 6.94633Z"
        fill="currentColor"
      />
      <path
        d="M16.8512 17.8329C17.9073 17.1733 18.8316 16.3562 19.6143 15.5212C20.516 14.5594 21.2096 13.5949 21.6776 12.8702C21.9112 12.5085 22.0874 12.2084 22.2044 12.0006V11.9994C22.0874 11.7916 21.9112 11.4914 21.6776 11.1298C21.2096 10.4051 20.516 9.44057 19.6143 8.47875C17.7981 6.54148 15.2203 4.69999 12 4.69999C9.63892 4.69999 7.62324 5.68988 5.99988 6.98165L5.00442 5.98619C6.81841 4.51127 9.16862 3.29999 12 3.29999C15.7797 3.29999 18.7019 5.4585 20.6357 7.52123C21.609 8.5594 22.3529 9.59491 22.8537 10.3702C23.1045 10.7585 23.2954 11.0834 23.4246 11.3131C23.4892 11.4279 23.5384 11.5191 23.5721 11.5827C23.5889 11.6145 23.6019 11.6395 23.6109 11.657L23.6214 11.6777L23.6245 11.6838L23.6258 11.6864C23.6718 11.7784 23.6964 11.8781 23.6995 11.9783C23.6998 11.9855 23.7 11.9927 23.7 12C23.7 12.007 23.6999 12.014 23.6996 12.0209C23.6966 12.1212 23.6721 12.221 23.6261 12.313L23.6 12.3L23.5994 12.3008C23.6256 12.3141 23.6255 12.3143 23.6255 12.3143L23.6245 12.3162L23.6214 12.3223L23.6109 12.343C23.6019 12.3605 23.5889 12.3854 23.5721 12.4172C23.5384 12.4808 23.4892 12.572 23.4246 12.6869C23.2954 12.9166 23.1045 13.2414 22.8537 13.6298C22.3529 14.4051 21.609 15.4406 20.6357 16.4787C19.8657 17.3 18.9391 18.1365 17.8641 18.8458L16.8512 17.8329Z"
        fill="currentColor"
      />
      <path
        d="M7.7692 10.7874C7.65901 11.1726 7.6 11.5794 7.6 12C7.6 14.4301 9.56995 16.4 12 16.4C12.4206 16.4 12.8274 16.341 13.2126 16.2308L11.9817 15C10.3394 14.9902 9.00985 13.6606 9.00005 12.0183L7.7692 10.7874Z"
        fill="currentColor"
      />
      <path
        d="M13.5732 14.5549C14.4294 14.0266 15 13.08 15 12C15 10.3432 13.6569 9.00001 12 9.00001C10.9201 9.00001 9.97339 9.57064 9.44507 10.4268L8.43659 9.41836C9.23624 8.31652 10.5344 7.60001 12 7.60001C14.4301 7.60001 16.4 9.56995 16.4 12C16.4 13.4656 15.6835 14.7638 14.5816 15.5634L13.5732 14.5549Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="search" viewBox="0 0 24 24" fill="none">
      <circle
        cx="10"
        cy="10"
        r="7"
        stroke="currentColor"
        strokeWidth="currentWidth"
      />
      <path
        d="M15.5 15.5L20 20"
        stroke="currentColor"
        strokeWidth="currentWidth"
        strokeLinecap="square"
      />
    </symbol>
    <symbol id="arrow-bottom" viewBox="0 0 24 24" fill="none">
      <path
        d="M4 8L12 16L20 8"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </symbol>
    <symbol id="arrow-right" viewBox="0 0 24 24" fill="none">
      <path
        d="M8 4L16 12L8 20"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </symbol>
    <symbol id="arrow-up" viewBox="0 0 16 16" fill="none">
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        d="m2.666 10.667 5.333-5.333 5.334 5.333"
      />
    </symbol>

    <symbol id="arrow-left" viewBox="0 0 24 24" fill="none">
      <path
        d="M16 4L8 12L16 20"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </symbol>
    <symbol id="calendar" viewBox="0 0 24 24" fill="none">
      <path
        d="M16 3V5"
        stroke="currentColor"
        strokeWidth="currentWidth"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M8 3V5"
        stroke="currentColor"
        strokeWidth="currentWidth"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M20 18.5V6.5C20 5.67157 19.3284 5 18.5 5H16H5.5C4.67157 5 4 5.67157 4 6.5V18.5C4 19.3284 4.67157 20 5.5 20H18.5C19.3284 20 20 19.3284 20 18.5Z"
        stroke="currentColor"
        strokeWidth="currentWidth"
      />
      <path
        d="M5 10L19 10"
        stroke="currentColor"
        strokeWidth="currentWidth"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </symbol>
    <symbol id="flag" viewBox="0 0 18 18" fill="none">
      <rect width="18" height="18" rx="9" fill="white" />
      <path
        d="M4.9 4.5H14.1L11.8 7.95L14.1 11.4H6.05V16H4.9V4.5Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="close" viewBox="0 0 24 24" fill="none">
      <path
        d="M18 18L6 6"
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M18 6L6 18"
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </symbol>
    <symbol id="alert-filled" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM11.1992 8H12.7992V13.2H11.1992V8ZM13 15.5C13 16.0523 12.5523 16.5 12 16.5C11.4477 16.5 11 16.0523 11 15.5C11 14.9477 11.4477 14.5 12 14.5C12.5523 14.5 13 14.9477 13 15.5Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="info-lined" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
        fill="currentColor"
      />
      <circle
        cx="12"
        cy="8"
        r="1"
        transform="rotate(-180 12 8)"
        fill="currentColor"
      />
      <rect
        x="12.6992"
        y="16.5"
        width="1.4"
        height="6.2"
        rx="0.4"
        transform="rotate(-180 12.6992 16.5)"
        fill="currentColor"
      />
    </symbol>
    <symbol id="heart" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 20C9.5 17.8333 4.30001 13 3.50001 11C2.50001 8.5 3.23496 6.1767 5.00001 5C6.5 3.99999 9.99999 3.49999 12 6.99999C14 3.49999 17.5 3.99999 19 5C20.765 6.1767 21.5 8.5 20.5 11C19.7 13 14.5 17.8333 12 20Z"
        stroke="var(--icon-stroke, currentColor)"
        strokeLinecap="square"
        fill="var(--icon-fill, currentColor)"
      />
    </symbol>
    <symbol id="big-dot" viewBox="0 0 26 26" fill="none">
      <rect
        x="8.5"
        y="8.5"
        width="9"
        height="9"
        rx="4.5"
        fill="currentColor"
        stroke="currentColor"
      />
    </symbol>
    <symbol id="dot" viewBox="0 0 26 26" fill="none">
      <rect x="10" y="10" width="6" height="6" rx="3" fill="currentColor" />
    </symbol>
    <symbol id="arrow-first" viewBox="0 0 18 18" fill="none">
      <path
        d="M9 3L3 9L9 15"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M14 3L8 9L14 15"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </symbol>
    <symbol id="arrow-last" viewBox="0 0 18 18" fill="none">
      <path
        d="M9 3L15 9L9 15"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M4 3L10 9L4 15"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </symbol>
    <symbol id="clock" viewBox="0 0 18 18" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 14.7273C12.1631 14.7273 14.7273 12.1631 14.7273 9C14.7273 5.83691 12.1631 3.27273 9 3.27273C5.83691 3.27273 3.27273 5.83691 3.27273 9C3.27273 12.1631 5.83691 14.7273 9 14.7273ZM9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 5.18182C9.35145 5.18182 9.63636 5.46673 9.63636 5.81819V8.73642L11.3591 10.4591C11.6076 10.7076 11.6076 11.1106 11.3591 11.3591C11.1106 11.6076 10.7076 11.6076 10.4591 11.3591L8.55002 9.44998C8.43068 9.33064 8.36364 9.16878 8.36364 9.00001V5.81819C8.36364 5.46673 8.64855 5.18182 9 5.18182Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="home" viewBox="0 0 20 20" fill="none">
      <path
        d="M2.26627 17.5011V15.7364H3.56705V17.5011C3.56705 17.6022 3.64856 17.6845 3.74966 17.6847H5.38443V18.9845H3.74966C2.93059 18.9843 2.26627 18.3202 2.26627 17.5011ZM9.55142 17.6847V18.9845H6.28189V17.6847H9.55142ZM13.7184 17.6847V18.9845H10.4489V17.6847H13.7184ZM16.4333 17.5011V15.7364H17.7331V17.5011C17.7331 18.3203 17.0689 18.9845 16.2497 18.9845H14.6149V17.6847H16.2497C16.3509 17.6847 16.4333 17.6023 16.4333 17.5011ZM2.26627 11.0177H3.56705V14.548H2.26627V11.0177ZM16.4333 11.0177H17.7331V14.548H16.4333V11.0177ZM2.26627 8.06457C2.26627 7.86506 2.35839 7.67608 2.51529 7.55285L3.86295 6.49426L4.66666 7.51672L3.56705 8.37902V9.82922H2.26627V8.06457ZM16.4333 8.37902L15.3336 7.51672L16.1364 6.49426L17.485 7.55285C17.6419 7.67608 17.7331 7.8651 17.7331 8.06457V9.82922H16.4333V8.37902ZM8.20767 4.73547L5.51138 6.85266L4.70865 5.83019L7.40494 3.71301L8.20767 4.73547ZM15.2917 5.83019L14.4879 6.85266L11.7917 4.73547L12.5954 3.71301L15.2917 5.83019ZM9.5983 1.99035C9.83394 1.80529 10.1654 1.80531 10.401 1.99035L11.7497 3.04894L10.9469 4.07141L10.4352 3.67004L9.99966 3.32727L9.05338 4.07141L8.25064 3.04894L9.5983 1.99035Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="star" viewBox="0 0 50 50" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.3492 6.0108C24.5549 5.37789 25.4503 5.37789 25.6559 6.0108L30.2151 20.0426H44.969C45.6345 20.0426 45.9112 20.8942 45.3728 21.2853L33.4367 29.9574L37.9959 43.9892C38.2015 44.6221 37.4771 45.1484 36.9387 44.7573L25.0026 36.0851L13.0664 44.7573C12.5281 45.1484 11.8037 44.6221 12.0093 43.9892L16.5685 29.9574L4.63237 21.2853C4.09398 20.8942 4.37067 20.0426 5.03616 20.0426H19.79L24.3492 6.0108Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="profile" viewBox="0 0 38 28" fill="none">
      <g clipPath="url(#clip0_3099_624)">
        <rect
          x="13.25"
          y="5.75"
          width="9.5"
          height="9.5"
          rx="4.75"
          stroke="currentColor"
          strokeWidth="currentWidth"
        />
        <rect
          x="6.25"
          y="18.75"
          width="22.5"
          height="24.5"
          rx="11.25"
          stroke="currentColor"
          strokeWidth="currentWidth"
        />
      </g>
      <defs>
        <clipPath id="clip0_3099_624">
          <rect width="38" height="28" fill="currentColor" />
        </clipPath>
      </defs>
    </symbol>
    <symbol id="receipt" viewBox="0 0 24 24" fill="none">
      <rect width="24" height="24" fill="transparent" />
      <path
        d="M17.5 17V6C17.5 5.44772 17.0523 5 16.5 5H14.75H7.5C6.94772 5 6.5 5.44772 6.5 6V14V17V19C6.5 19.5523 6.94771 20 7.5 20H14.5C16.1569 20 17.5 18.6569 17.5 17Z"
        stroke="black"
        strokeWidth="currentWidth"
      />
      <path
        d="M11.5 16C12.0523 16 12.4759 16.4551 12.6039 16.9924C12.8334 17.9556 13.4881 18.7441 15 19.5C16.5 20 12.9055 20 12.5 20H6C3.7355 20 3.11195 19.5898 2.64297 16.9113C2.55901 16.4318 2.93557 16 3.42241 16H6.99926H11.5Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="currentWidth"
      />
      <path d="M9 9H15" stroke="currentColor" strokeWidth="currentWidth" />
      <path d="M9 12.5H15" stroke="currentColor" strokeWidth="currentWidth" />
    </symbol>
    <symbol id="email" viewBox="0 0 25 24" fill="none">
      <rect
        width="24"
        height="24"
        transform="translate(0.5)"
        fill="transparent"
      />
      <path
        d="M4.5 7L12.5 13L20.5 7"
        stroke="currentColor"
        strokeWidth="currentWidth"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M20.5 16.5V7.5C20.5 6.94772 20.0523 6.5 19.5 6.5H16.5H5.5C4.94772 6.5 4.5 6.94772 4.5 7.5V16.5C4.5 17.0523 4.94772 17.5 5.5 17.5H19.5C20.0523 17.5 20.5 17.0523 20.5 16.5Z"
        stroke="currentColor"
        strokeWidth="currentWidth"
      />
    </symbol>
    <symbol id="marker" viewBox="0 0 17 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8.18182V8.57727C0 10.5273 0.694167 12.4227 1.955 13.9364L8.5 24L15.1111 13.9364C16.3719 12.4091 17 10.5273 17 8.57727V8.18182C17 3.66818 13.1892 0 8.5 0C3.81083 0 0 3.66818 0 8.18182ZM8.5 10.9091C10.0583 10.9091 11.3333 9.68182 11.3333 8.18182C11.3333 6.68182 10.0583 5.45455 8.5 5.45455C6.94167 5.45455 5.66667 6.68182 5.66667 8.18182C5.66667 9.68182 6.94167 10.9091 8.5 10.9091Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="plus" viewBox="0 0 17 16" fill="none">
      <path
        d="M8.5 13.6575V2.34375"
        stroke="currentColor"
        strokeWidth="currentWidth"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M14.1569 8.0006H2.84315"
        stroke="currentColor"
        strokeWidth="currentWidth"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </symbol>
    <symbol id="minus" viewBox="0 0 16 16" fill="none">
      <path
        d="M13.6569 8.00012H2.34315"
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </symbol>
    <symbol id="filter" viewBox="0 0 16 16" fill="none">
      <path d="M3.5 5L12.5 5" stroke="currentColor" strokeLinecap="square" />
      <path d="M12.5 11L3.5 11" stroke="currentColor" strokeLinecap="square" />
      <rect
        x="10"
        y="3.5"
        width="3"
        height="3"
        rx="1.5"
        fill="white"
        stroke="currentColor"
      />
      <rect
        width="3"
        height="3"
        rx="1.5"
        transform="matrix(-1 0 0 1 6 9.5)"
        fill="white"
        stroke="currentColor"
      />
    </symbol>
    <symbol id="share" viewBox="0 0 24 24" fill="none">
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
        strokeWidth="currentWidth"
        d="M20 18v-4.5M4 18v-4.5M19 18H5"
      />
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="currentWidth"
        d="m8 9 4-4 4 4"
      />
      <path stroke="currentColor" strokeWidth="currentWidth" d="M12 5v9" />
    </symbol>
    <symbol id="more" viewBox="0 0 24 24" fill="none">
      <rect
        x="13.5"
        y="4.5"
        width="3"
        height="3"
        rx="1.5"
        transform="rotate(90 13.5 4.5)"
        fill="currentColor"
      />
      <rect
        x="13.5"
        y="10.5"
        width="3"
        height="3"
        rx="1.5"
        transform="rotate(90 13.5 10.5)"
        fill="currentColor"
      />
      <rect
        x="13.5"
        y="16.5"
        width="3"
        height="3"
        rx="1.5"
        transform="rotate(90 13.5 16.5)"
        fill="currentColor"
      />
    </symbol>
    <symbol id="edit" viewBox="0 0 16 16" fill="none">
      <path
        d="M8.33329 2.6665H4.16663C3.3382 2.6665 2.66663 3.33808 2.66663 4.16651V11.8332C2.66663 12.6616 3.3382 13.3332 4.16663 13.3332H11.8333C12.6617 13.3332 13.3333 12.6616 13.3333 11.8332V7.99984"
        stroke="currentColor"
      />
      <path
        d="M12.2908 2L13.9979 3.70711L7.73849 9.9665L5.74686 10.251L6.03138 8.25939L12.2908 2Z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </symbol>
    <symbol id="arrowbar-left" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="currentWidth"
        d="m11 4-8 8 8 8"
      />
      <path stroke="currentColor" strokeWidth="currentWidth" d="M21 12H3" />
    </symbol>
    <symbol id="download" viewBox="0 0 16 16" fill="none">
      <path
        d="M13.3333 12L13.3333 9"
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M2.66675 12L2.66675 9"
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12.6667 12L2.66675 12"
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M5.33325 6.66683L7.99992 9.3335L10.6666 6.66683"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path d="M8 9.3335L8 3.3335" stroke="currentColor" />
    </symbol>
    <symbol id="refresh" viewBox="0 0 16 16" fill="none">
      <path
        d="M12.5498 5.99337C12.5498 6.29679 12.3044 6.54368 12.001 6.54416L8.95116 6.54806L8.94921 5.44845L10.7422 5.44552C10.5888 5.27356 10.4194 5.1118 10.2334 4.9631C8.4282 3.52039 5.79427 3.81417 4.35155 5.61935C2.90913 7.42453 3.20369 10.0576 5.00878 11.5002C6.81383 12.9424 9.44601 12.6486 10.8887 10.844C11.3327 10.2883 11.6118 9.65389 11.7334 9.00021H12.7471C12.629 9.79186 12.3274 10.5663 11.832 11.2551L11.6699 11.468C9.93829 13.6343 6.823 14.0439 4.59667 12.4426L4.38475 12.2815C2.21824 10.55 1.80808 7.43463 3.40917 5.20822L3.5703 4.99533C5.3578 2.75873 8.62079 2.39441 10.8574 4.18185L11.0615 4.35373C11.1993 4.47579 11.3285 4.60427 11.4502 4.73751V3.04806H12.5498V5.99337Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="message" fill="none" viewBox="0 0 16 16">
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="m8 15-2.1-3.333H2.4c-.773 0-1.4-.597-1.4-1.334v-8C1 1.597 1.627 1 2.4 1h11.2c.773 0 1.4.597 1.4 1.333v8c0 .737-.627 1.334-1.4 1.334h-3.5L8 15Z"
      />
      <rect width="2" height="2" x="3.6" y="5.199" fill="currentColor" rx="1" />
      <rect width="2" height="2" x="7" y="5.199" fill="currentColor" rx="1" />
      <rect
        width="2"
        height="2"
        x="10.4"
        y="5.199"
        fill="currentColor"
        rx="1"
      />
    </symbol>
    <symbol id="map" viewBox="0 0 16 16" fill="none">
      <path
        fill="currentColor"
        d="M8 1.332c2.945 0 4.667 2.09 4.667 4.667 0 3.384-3.494 7.401-4.436 8.422a.31.31 0 0 1-.461 0c-.941-1.02-4.437-5.038-4.437-8.422 0-2.577 1.722-4.667 4.667-4.667Zm0 2.667a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
      />
    </symbol>
    <symbol id="notification" viewBox="0 0 24 24" fill="none">
      <path
        d="M9 18.5C9.16667 19.3333 10 21 12 21C14 21 14.8333 19.3333 15 18.5"
        stroke="currentColor"
        strokeWidth="currentWidth"
        strokeLinejoin="round"
      />
      <path
        d="M12 4.74609C14.8501 4.74609 17.1668 7.0445 17.1895 9.89453L17.1982 11.0059L17.1992 11.0977L17.2217 11.1855L18.6387 16.7012C18.8408 17.4879 18.2468 18.2539 17.4346 18.2539H6.56543C5.75318 18.2539 5.15919 17.4879 5.36133 16.7012L6.77832 11.1855L6.80078 11.0977L6.80176 11.0059L6.81055 9.89453C6.83322 7.0445 9.14986 4.74609 12 4.74609Z"
        stroke="currentColor"
        strokeWidth="currentWidth"
      />
      <path
        d="M12 2.5V4.5"
        stroke="currentColor"
        strokeWidth="currentWidth"
        strokeLinejoin="round"
      />
    </symbol>
  </svg>
)
